import React, { useState } from "react";
import "./index.scss";
function WebPage(props) {
  const Components = props.component;

  return (
 
      <Components />
   
  );
}

export default WebPage;
